<template>
    <VButton :label="__('Increase availability')" variant="secondary" size="sm" @onClick="showAvailabilityCalendar" />
</template>

<script>
export default {
    methods: {
        showAvailabilityCalendar() {
            let firstAllowedDate = moment().add(1, 'day')

            if (this.user.country !== 'DE') {
                firstAllowedDate = moment().add(3, 'days')
            }

            const uri = new URI(`/pridat-dostupnost/${firstAllowedDate.format('YYYY-MM-DD')}`)

            location.href = uri.readable()
        }
    }
}
</script>
